import Icons from "../../../../../components/icons";

const PricingFooter = () => {
  return (
    <div className="mt-10">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-5 text-center lg:text-left">
        <p className="text-sm text-muted-foreground">All plans include all popular LLMs and over 2000+ integrations</p>

        <div className="flex gap-5 flex-wrap justify-center items-center">
          <Icons id="googleWorld" />
          <Icons id="googlePowerPoint" />
          <Icons id="googleSheet" />
          <Icons id="googleAdds" />
          <Icons id="googleAnalytics" />
          <Icons id="metaAdds" />
          <Icons id="facebook" />
          <Icons id="instagram" />
          <span className="text-sm font-medium text-muted-foreground">+1000’s more</span>
        </div>
      </div>
    </div>
  );
};

export default PricingFooter;
